var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIDayLunch02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03893 9.01585C7.68465 9.01585 9.01878 7.68173 9.01878 6.036C9.01878 4.39028 7.68465 3.05615 6.03893 3.05615C4.39321 3.05615 3.05908 4.39028 3.05908 6.036C3.05908 7.68173 4.39321 9.01585 6.03893 9.01585Z",
    fill: "#3284FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03903 2.43592C6.22918 2.43592 6.41672 2.45416 6.59905 2.48281L6.03903 0.787109L5.479 2.48281C5.66134 2.45416 5.84888 2.43592 6.03903 2.43592Z",
    fill: "#3284FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15674 3.12893C8.4615 3.35033 8.72718 3.61862 8.94859 3.92077L9.75085 2.32666L8.15674 3.12893Z",
    fill: "#3284FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2865 6.03463L9.59082 5.47461C9.61947 5.65694 9.63771 5.84449 9.63771 6.03463C9.63771 6.22478 9.61947 6.41232 9.59082 6.59466L11.2865 6.03463Z",
    fill: "#3284FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94859 8.15234C8.72718 8.4571 8.45889 8.72279 8.15674 8.94419L9.75085 9.74646L8.94859 8.15234Z",
    fill: "#3284FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03903 9.63771C5.84888 9.63771 5.66134 9.61947 5.479 9.59082L6.03903 11.2865L6.59905 9.59082C6.41672 9.61947 6.22918 9.63771 6.03903 9.63771Z",
    fill: "#3284FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13186 8.15234L2.32959 9.74646L3.9237 8.94419C3.61895 8.72279 3.35326 8.4545 3.13186 8.15234Z",
    fill: "#3284FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43885 6.03463C2.43885 5.84449 2.45709 5.65694 2.48574 5.47461L0.790039 6.03463L2.48574 6.59466C2.45709 6.41232 2.43885 6.22478 2.43885 6.03463Z",
    fill: "#3284FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9237 3.12893L2.32959 2.32666L3.13186 3.92077C3.35326 3.61602 3.62155 3.35033 3.9237 3.12893Z",
    fill: "#3284FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDayLunch02);
export default __webpack_public_path__ + "static/media/i_day_lunch_02.37cdd70de4ab1a75b368d40732761b06.svg";
export { ForwardRef as ReactComponent };